$(document).ready(function () {
    if($('#customize-pendent-block').length > 0){
        function update_customize_property(){
            $('#property-customize-pendant-name').val($('#customize-pendent-input').val());
            $('#property-customize-pendant-style').val($('#customize-pendent-opt-row input[type=radio]:checked').val());
        }

        $('#customize-pendent-block').addClass('loaded');
        $('#property-customize-pendant-name').parents('form').find('.accelerated-checkout-block').addClass('disabled');
        const maxLength = 10;
        $('#customize-pendent-input').on('keyup', function () {
            let value = $(this).val();
            value = value.replace(/[^a-zA-Z]/g, '');

            if (value.length > maxLength) {
                value = value.substring(0, maxLength);
            }
            $(this).val(value);
            

            if (value.length > 0){
                $('#customize-pendent-block .pendent-opt-style').text(value);
                $('#customize-pendent-preview .preview-name').text(value);
                $('#property-customize-pendant-name').parents('form').find('.accelerated-checkout-block').removeClass('disabled');
            }else{
                $('#property-customize-pendant-name').parents('form').find('.accelerated-checkout-block').addClass('disabled');
                $('#customize-pendent-block .pendent-opt-style').text($('#customize-pendent-opt-row').data('default-name'));
                $('#customize-pendent-preview .preview-name').text($('#customize-pendent-preview .preview-name').data('default'));
            }
            update_customize_property();
            $('#customize-pendent-error').addClass('hidden');
            $(this).siblings('.counter').text(value.length + '/' + maxLength);
            (value.length > 5)? $('#customize-pendent-block').addClass('font-level-2'): $('#customize-pendent-block').removeClass('font-level-2');
            (value.length > 7)? $('#customize-pendent-block').addClass('font-level-3'): $('#customize-pendent-block').removeClass('font-level-3');
        });

        $('#customize-pendent-opt-row input').on('change', function () {
            var value = $(this).val();
            var font = $(this).data('font');
            $('#property-customize-pendant-style').val(value);
            $('#customize-pendent-preview .preview-name').css('font-family','"'+ font +'" , cursive');
            update_customize_property();
        });
        $(document).on('click','.accelerated-checkout-block.disabled',function(){
            $('#customize-pendent-input').focus();
            $('#customize-pendent-error').removeClass('hidden');
        });
    }
})